import { render } from "./ShreeShubhanand.vue?vue&type=template&id=5198ed2f"
import script from "./ShreeShubhanand.vue?vue&type=script&lang=js"
export * from "./ShreeShubhanand.vue?vue&type=script&lang=js"

import "./ShreeShubhanand.vue?vue&type=style&index=0&id=5198ed2f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__